<template>
  <div class="home">
    <h2>Tester IP Addresses</h2>

    <b-button @click="raisePopup({ target: $event.target })" variant="primary"
      >Add new</b-button
    >
    <b-button
      @click="raisePopupImport({ target: $event.target })"
      class="ml-2"
      variant="primary"
      >Import from file</b-button
    >
    <!-- Filtering -->
    <b-row>
      <b-col md="12" class="my-1">
        <b-form-group label-cols-sm="1" label="Filter" class="mb-0">
          <b-input-group>
            <b-form-input
              v-model="filter.vendor"
              placeholder="by Vendor"
              @keypress.enter="forceFilter"
            />
            <b-form-input
              v-model="filter.ip"
              placeholder="by IP Address"
              @keypress.enter="forceFilter"
            />

            <b-input-group-append>
              <b-button
                :disabled="!filter.vendor && !filter.ip"
                @click="
                  filter = {};
                  forceFilter();
                "
                >Clear</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Info modal -->
    <b-modal
      id="testerIPModal"
      :title="this.isEdit ? 'Edit tester IP' : 'New tester IP'"
      @ok="testerIPFormSubmit"
      :ok-disabled="!isFormValid"
    >
      <b-form>
        <input id="newTesterIPInput0" type="hidden" v-model="form.vendor" />
        <b-input-group
          id="newTesterIPInputGroup4"
          label="Vendor"
          label-for="newTesterIPInput4"
        >
          <b-form-select v-model="form.vendor" id="newTesterIPInput1">
            <option :value="null" disabled>Choose the vendor</option>
            <option value="samsung">Samsung</option>
            <option value="lg">LG</option>
            <option value="custom">Custom</option>
          </b-form-select>
        </b-input-group>
        <b-row class="mt-4">
          <b-col md="8">
            <b-form-group
              id="newTesterIPInputGroup5"
              label="IP/Mask (mask is 32 by default):"
              label-for="newTesterIPInput5"
            >
              <b-form-input
                id="newTesterIPInput5"
                type="text"
                v-model="form.ip"
                placeholder="255.255.255.0/32"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group
          id="newTesterIPInputGroup6"
          label="Description:"
          label-for="newTesterIPInput6"
        >
          <b-form-textarea
            id="newTesterIPInput6"
            v-model="form.description"
            placeholder="Enter description..."
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-form-group>
      </b-form>
    </b-modal>
    <!-- import modal -->
    <b-modal
      id="testerIPModalImport"
      :title="'Load IPs from file'"
      @ok="importIPFormSubmit"
      :ok-disabled="importForm.ipArray.length === 0"
    >
      <b-form>
        <input
          id="newTesterIPInput0"
          type="hidden"
          v-model="importForm.vendor"
        />
        <b-input-group
          id="newTesterIPInputGroup4"
          label="Vendor"
          label-for="newTesterIPInput4"
        >
          <b-form-select v-model="importForm.vendor" id="newTesterIPInput1">
            <option :value="null" disabled>First choose the vendor</option>
            <option value="samsung">Samsung</option>
            <option value="lg">LG</option>
          </b-form-select>
        </b-input-group>
      </b-form>
      <input
        type="file"
        ref="file"
        style="display: none"
        @change="loadIPFromFile"
      />
      <b-button
        @click="$refs.file.click()"
        :disabled="!importForm.vendor"
        variant="primary"
        class="mt-3"
        >Open file</b-button
      >
      <p class="my-3" v-if="importForm.ipArray.length">
        Mask 32 will be added where it's not provided
      </p>
      <b-table :items="importForm.ipArray"></b-table>
    </b-modal>

    <b-container fluid>
      <b-row>
        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="2" label="Sort" class="mb-0">
            <b-input-group>
              <b-form-select v-model="sortBy" :options="sortOptions">
                <option slot="first" :value="null">-- none --</option>
              </b-form-select>
              <b-form-select
                :disabled="!sortBy"
                v-model="sortDesc"
                slot="append"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col md="6" class="my-1">
          <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
            <b-form-select :options="pageOptions" v-model="perPage" />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        small
        hover
        stacked="md"
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        ref="testerIPTable"
        class="testerIPTable"
      >
        <template v-slot:cell(actions)="row">
          <b-button
            size="sm"
            class="m-1"
            @click="row.toggleDetails"
            variant="info"
            >…</b-button
          >
          <b-button
            size="sm"
            class="m-1"
            variant="warning"
            @click="
              raisePopup({
                target: $event.target,
                isEdit: true,
                testerIP: row.item
              })
            "
            >✎</b-button
          >
          <b-button
            size="sm"
            variant="danger"
            class="m-1 ml-3"
            @click="
              removeTesterIP({
                target: $event.target,
                testerIP: row.item
              })
            "
            >X</b-button
          >
        </template>
        <template v-slot:cell(active)="row">{{
          row.value ? 'Yes' : 'No'
        }}</template>

        <template v-slot:row-details="row">
          <b-card>
            <ul>
              <li v-for="(value, key) in row.item" :key="key">
                {{ key }}: {{ value }}
              </li>
            </ul>
          </b-card>
        </template>
      </b-table>

      <b-row>
        <b-col md="6" class="my-1">
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            class="my-0"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
/* eslint-disable no-magic-numbers */
import formatIPInput from '../helpers/formatIPInput';
const originalForm = {
  id: null,
  ip: null,
  vendor: null,
  description: null
};
const originalImportForm = {
  vendor: null,
  ipArray: new Array(),
  description: null
};

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 100, 500],
      sortBy: null,
      sortDesc: false,
      filter: {
        vendor: '',
        ip: ''
      },
      form: {
        ...originalForm
      },
      importForm: {
        ...originalImportForm
      },
      isEdit: false,
      ipRegEx: new RegExp(
        /^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^\d{1,3}(\.\d{1,3}){3}\/(3[0-2]|[1-2]\d|\d)$/
      )
    };
  },

  computed: {
    isFormValid() {
      if (!this.form.vendor) return false;

      if (!this.ipRegEx.test(this.form.ip)) return false;
      return true;
    },
    formIsActive: {
      get: function() {
        return !!this.form.active;
      },
      set: function(newValue) {
        this.form.active = newValue;
      }
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    },
    fields() {
      return [
        {
          key: 'id',
          label: 'id',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'ip',
          label: 'IP',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'vendor',
          label: 'Vendor',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'createdAt',
          label: 'Created',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'updatedAt',
          label: 'Updated',
          sortable: true,
          class: 'text-center'
        },
        { key: 'actions', label: 'Actions' }
      ];
    },
    totalRows() {
      return this.$store.state.testerIP.count;
    }
  },
  methods: {
    raisePopup({ target, isEdit = false, testerIP = null }) {
      this.isEdit = isEdit;
      if (testerIP && isEdit) {
        this.form = Object.keys(originalForm).reduce(
          (acc, current) =>
            testerIP[current]
              ? {
                  ...acc,
                  [current]: String(testerIP[current])
                }
              : acc,
          {}
        );
      } else {
        this.testerIPFormReset();
      }
      this.$root.$emit('bv::show::modal', 'testerIPModal', target);
    },
    raisePopupImport({ target }) {
      this.importIPFormReset();
      this.$root.$emit('bv::show::modal', 'testerIPModalImport', target);
    },
    loadIPFromFile(ev) {
      const file = ev.target.files[0];
      const reader = new FileReader();
      reader.onload = e => this.populateImportIPArray(e.target.result);
      reader.readAsText(file);
    },
    populateImportIPArray(result) {
      const arrayOfIPAndRanges = formatIPInput(result);
      arrayOfIPAndRanges.forEach(item => {
        this.importForm.ipArray.push({
          ip: item,
          vendor: this.importForm.vendor
        });
      });
    },
    removeTesterIP({ testerIP = null }) {
      if (!testerIP) {
        return;
      }
      const promise = this.$store.dispatch('removeTesterIP', testerIP.id);

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        this.$refs.testerIPTable.refresh();
      });
    },
    forceFilter() {
      this.onFiltered();
      this.$refs.testerIPTable.refresh();
    },
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
    },
    items(ctx) {
      const currentFilter = Object.keys(this.filter).reduce(
        (acc, curr) =>
          this.filter[curr] ? { ...acc, [curr]: this.filter[curr] } : acc,
        {}
      );

      const promise = this.$store.dispatch('getTesterIP', {
        ctx,
        filter: currentFilter
      });

      // Must return a promise that resolves to an array of items
      return promise.then(() => {
        const items = this.$store.state.testerIP.rows.map(ip => {
          if (ip.active) {
            ip._rowVariant = 'success';
          }
          return ip;
        });
        // Must return an array of items or an empty array if an error occurred
        return items || [];
      });
    },
    testerIPFormReset() {
      this.form = { ...originalForm };
    },
    importIPFormReset() {
      this.importForm = { ...originalImportForm };
      this.importForm.ipArray = [];
    },
    async testerIPFormSubmit(event) {
      let payload = { ...this.form };
      let ip = payload.ip;
      if (!ip.includes('/')) {
        ip += '/32';
        payload = { ...payload, ip };
      }
      if (!this.isEdit) {
        await this.$store.dispatch('addTesterIP', {
          payload,
          event
        });
      } else {
        await this.$store.dispatch('editTesterIP', {
          payload,
          event
        });
      }

      this.testerIPFormReset();
      this.$refs.testerIPTable.refresh();
    },
    async importIPFormSubmit(event) {
      const payload = this.importForm.ipArray.map(item => {
        if (item.ip.includes('/')) return item;
        const withMask = item.ip + '/32';
        return { ...item, ip: withMask };
      });
      await this.$store.dispatch('addTesterIPArray', {
        payload,
        event
      });
      this.importIPFormReset();
      this.$refs.testerIPTable.refresh();
    }
  }
};
</script>
<style scoped type="text/scss">
.block {
  border-bottom: #dadada 1px solid;
  padding-bottom: 1em;
  margin-bottom: 3em;
}
.container {
  max-width: none;
}
.testerIPTable {
  font-size: 0.8rem;
}
.btn {
  font-size: 0.8rem;
}

td[data-label='Actions'] {
  white-space: nowrap;
}
</style>
